export default __webpack_public_path__ + "static/media/hashlogo.af3f2ea0.png";